export var DEALER_LOGO_TITLE = {
  SCHEDULING_TEXT_LOGO: 'SCHEDULING_TEXT_LOGO',
  SCHEDULING_MAKE_LOGO: 'SCHEDULING_MAKE_LOGO',
  SCHEDULING_APPOINTMENT_EMAIL_DEALER_LOGO_TOP_CENTER: 'SCHEDULING_APPOINTMENT_EMAIL_DEALER_LOGO_TOP_CENTER',
  MAKE_LOGO_TRANSPARENT: 'MAKE_LOGO_TRANSPARENT',
  MOBILE_DEALER_LOGO: 'MOBILE_DEALER_LOGO',
  DEALERSHIP_BANNER_IMAGE: 'DEALERSHIP_BANNER_IMAGE'
};
export var DEALER_PROPERTY = {
  CCPA_ENABLED: 'CCPA_ENABLED',
  CLOCKINV3_ENABLED: 'CLOCKINV3_ENABLED',
  CONSUMER_PORTAL_ENABLED: 'CONSUMER_PORTAL_ENABLED',
  IS_NETCHEX_DOWNLOAD_CSV_ENABLED: 'IS_NETCHEX_DOWNLOAD_CSV_ENABLED',
  NEW_DSE_ENABLED: 'NEW_DSE_ENABLED',
  DSDA_DOCUMENTS: 'DSDA_DOCUMENTS',
  NEW_VENDOR_CHANGE_DISPLAY_NUMBER_CONTROL: 'NEW_VENDOR_CHANGE_DISPLAY_NUMBER_CONTROL',
  NEW_CUSTOMER_CHANGE_DISPLAY_NUMBER_CONTROL: 'NEW_CUSTOMER_CHANGE_DISPLAY_NUMBER_CONTROL',
  EMPLOYEE_OT_CONFIG_STATE_LEVEL: 'EMPLOYEE_OT_CONFIG_STATE_LEVEL',
  // moving OtConfiguration from dealer master to dealer State level
  GM_CARD_FEATURE_ENABLED: 'GM_CARD_FEATURE_ENABLED',
  UNEXCUSED_REASON_ENABLED: 'UNEXCUSED_REASON_ENABLED'
};